import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, useQueryStates } from 'nuqs';

export default function useExamLocationGrantAccessRoomListSearchParams() {
  const [{ page, pageSize, search }, setExamLocationGrantAccessRoomListSearchParams] =
    useQueryStates({
      page: parseAsPageNumber.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
      search: parseAsString.withDefault(''),
    });

  const changePageNumber = (page: number) => {
    setExamLocationGrantAccessRoomListSearchParams({ page });
  };

  const changePageSize = (pageSize: number) => {
    setExamLocationGrantAccessRoomListSearchParams({ pageSize, page: 0 });
  };

  const changeSearch = (search: string) => {
    setExamLocationGrantAccessRoomListSearchParams({ search, page: 0 });
  };

  return [
    { page, pageSize, search },
    {
      changeSearch,
      changePageNumber,
      changePageSize,
    },
  ] as const;
}
